import { render } from "./PersonalNotifications.vue?vue&type=template&id=148736ea&scoped=true"
import script from "./PersonalNotifications.vue?vue&type=script&lang=js"
export * from "./PersonalNotifications.vue?vue&type=script&lang=js"

import "./PersonalNotifications.vue?vue&type=style&index=0&id=148736ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148736ea"]])

export default __exports__